<template>
  <div>
    <!-- <div class="box-header">
      <h3 class="box-title">{{ $t( siteNameInfo === 2
        ? 'sidebar.mobileHomeManagement.apartmentInfo'
        : "homeMobileManagement.title") }}</h3>
    </div> -->
    <div>
      <div class="panel with-nav-tabs panel-primary">
            <div class="panel-heading">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a href="#tab1primary" data-toggle="tab">{{
                    $t("templateNotification.category.list")
                  }}</a>
                </li>
                <li>
                  <a href="#tab2primary" data-toggle="tab">{{
                    $t("sidebar.customerfeedbackmanagement.emailform")
                  }}</a>
                </li>
                <!-- <li>
                  <a href="#tab3primary" data-toggle="tab">{{
                    $t("sidebar.projectsettings.usingemailtemplate")
                  }}</a>
                </li> -->
              </ul>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="tab1primary">
                  <notification-category ref="notificationCategory"/>
                </div>
                <div class="tab-pane fade" id="tab2primary">
                  <management-email-form-list ref="managementEmailFormList"/>
                </div>
                <div class="tab-pane fade" id="tab3primary">
                  <!-- <project-email-template ref="projectEmailTemplate"/> -->
                </div>
              </div>
            </div>
          </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import NotificationCategory from "./NotificationCategory"
import ManagementEmailFormList from '../Mailbox/EmailCategory.vue'
// import ProjectEmailTemplate from '../Project/ProjectEmailTemplate.vue'
import config from "../../../build/config"
// import utils from '@/lib/utils'

export default {
  components: {
    NotificationCategory,
    ManagementEmailFormList,
    // ProjectEmailTemplate
  },
  data: () => ({
    siteNameInfo: config.SITE_NAME_INFO
  }),
  methods: {
    ...mapActions([
    ])
  },
  mounted() {
  }
}
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
</style>


// WEBPACK FOOTER //
// src/views/Notification/NotificationCategoryTabs.vue